// Vue.prototype.$함수명 = function(data){}

const methods = {
  scrollToTop: () => {
    window.scroll(0, 0)
    return false
  },
  scrollSmoothToTop: value => {
    this.intervalId = setInterval(() => {
      if (window.scrollY === 0) {
        clearInterval(this.intervalId)
      }
      window.scroll(0, window.scrollY - 50)
    }, value)
    return false
  }
}

export default {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$scrollToTop = methods.scrollToTop
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$scrollSmoothToTop = methods.scrollSmoothToTop

    // // ajax post
    // Vue.prototype.$post = function(callUrl, postData, succ, fail) {
    //   const URL = `${config.contextRoot}${callUrl}`
    //   axios
    //     .post(URL, postData, requestOptions)
    //     .then(result => {
    //       succ(result.data, this)
    //     })
    //     .catch(e => {
    //       fail(e, this)
    //     })
    // }
    //
    // // 이메일 정규식
    // Vue.prototype.$emailValidation = function(data) {
    //   const regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i
    //   if (regExp.test(data)) {
    //     // 통과
    //     return true
    //   }
    //   // 올바르지 않음
    //   return false
    // }

    // const target = window.location.hash
    // console.info(window.location)
    // console.info(target)
    // if (target !== '') {
    //   window.scrollTo(0, 0)
    //   // $('html, body').stop().animate({scrollTop : $(target).offset().top - 180},800);
    // }
  }
}

// $(function(){
// 	// Mobile Ui
// 	$('.top_btn').on('click', function() {
// 		$('html, body').stop().animate({scrollTop:0}, '500');
// 		return false;
// 	});
//
// 	var target = location.hash;
// 	if(target != ""){
// 		$('html, body').stop().animate({scrollTop : $(target).offset().top - 180},800);
// 	}
//
// 	$('#sub.view_idx .box_wrap .ul_wrap ul li a').click(function(event){
//             event.preventDefault();
//             $('html,body').stop().animate({scrollTop:$(this.hash).offset().top - 100}, 500);
//     });
// 	var mobile = {
// 		open : function(){
// 			$('.mo_all_menu').stop().animate({'left':'0'},400,'easeInOutQuad');
// 		},
// 		close : function(){
// 			$('.mo_all_menu').stop().animate({'left':'-100%'}, 400, 'easeInOutQuad');
// 		},
// 		down : function(target){
// 			$(target).addClass('on');
// 			$(target).next().stop().slideDown(400,'easeInOutQuad');
//
// 		},
// 		up : function(target){
// 			$(target).removeClass('on');
// 			$(target).next().stop().slideUp(400, 'easeInOutQuad');
// 		},
// 		siblingsUp : function(target){
// 			$(target).parent().siblings('li').children('a').removeClass('on');
// 			$(target).parent().siblings('li').children('ul').stop().slideUp(400, 'easeInOutQuad');
// 		},
// 		bgOn : function(){
// 			$('.mbg').stop().fadeIn(400);
// 		},
// 		bgOff : function(){
// 			$('.mbg').stop().fadeOut(400);
// 		}
// 	}
//
//
// 	$('#fixed_header .all_btn a.mo').on('click',function(){
// 		mobile.open();
// 		//mobile.bgOn();
// 		//$('html,body').css({'overflow':'hidden' , 'height' : '100%'});
// 		//$.fn.fullpage.setAutoScrolling(false);
// 	});
// 	$('.mo_all_menu .tp_wrap .l_box a.close').on('click',function(){
// 		mobile.close();
// 		mobile.bgOff();
// 		//$('html,body').css({'overflow':'visible' , 'height' : 'initial'});
// 	});
//
// 	$('.header_banner  a.cl_bt').on('click', function(){
// 		$(this).css('opacity','0');
// 		$('.header_banner').stop().slideUp(400);
// 	});
//
// 	$('.mgnb .depth1 > li > a').on('click',function(){
// 		mobile.siblingsUp(this);
// 		if($(this).hasClass('on')){
// 			mobile.up(this);
// 		}else{
// 			mobile.down(this);
// 		}
// 	});
// 	$('.list_wrap .list_box a.bf').on('click',function(){
// 		if($(this).hasClass('on')){
//
// 			$(this).removeClass('on');
// 			$(this).siblings('.wrap').stop().slideUp(400);
// 		}else{
// 			//$('.list_wrap .list_box .wrap').stop().slideUp(400);
// 			//$('.list_wrap .list_box a.bf').removeClass('on');
// 			$(this).addClass('on');
// 			$(this).siblings('.wrap').stop().slideDown(400);
//
// 		}
// 	});
//
//
// /*	var cartFlag = false;
//
// 	$('#header li.mp').on('mouseover',function(){
//
// 		if($(this).hasClass('on')){
//
// 		}else{
// 			if(cartFlag == false) {
// 				$(this).addClass('on');
// 				$(this).find('.dept').stop().slideDown(400);
// 			}
// 			cartFlag = true;
// 		}
// 	}).on('mouseleave',function(){
// 		if($(this).hasClass('on')){
// 			$(this).removeClass('on');
// 				$(this).find('.dept').stop().slideUp(400);
// 		}else{
// 			if(cartFlag == true){
// 				$(this).removeClass('on');
// 				$(this).find('.dept').stop().slideUp(400);
// 			}
// 			cartFlag = false;
// 		}
// 	});*/
// 	$('#header li.mp').on('mouseenter',function(){
// 		$(this).addClass('on');
// 		$(this).find('.dept').stop().slideDown(400);
// 	});
//
// 	$('#header li.mp').on('mouseleave',function(){
// 		$(this).removeClass('on');
// 		$(this).find('.dept').stop().slideUp(400);
// 	});
//
// 	var recom = new Swiper('.btm_header .recom_sl .swiper-container', {
// 		slidesPerView:1,
// 		direction:'vertical',
// 		loop:true,
// 		simulateTouch:false,
// 		autoplay: {
// 			delay: 2000,
// 		},
// 		height:72,
// 	});
// 	var recom2 = new Swiper('.mo_all_menu .recom_sl .swiper-container', {
// 		slidesPerView:1,
// 		direction:'vertical',
// 		loop:true,
// 		simulateTouch:false,
// 		autoplay: {
// 			delay: 2000,
// 		},
// 		height:72,
// 	});
// 	var quick = new Swiper('#quick_menu .swiper-container', {
// 		loop:true,
// 		navigation: {
// 			nextEl: '#quick_menu .r_btn',
// 			prevEl: '#quick_menu .l_btn',
// 		},
//       });
//
// 	$('#main .best_list .tab_list ul li').on('click',function(){
// 		var idx = $(this).index();
//
// 		$('#main .best_list .tab_list ul li').removeClass('on');
// 		$('#main .best_list .tab_list ul li').eq(idx).addClass('on');
// 		$('#main .best_list .tab_wrap .tab_box').removeClass('on');
// 		$('#main .best_list .tab_wrap .tab_box').eq(idx).addClass('on');
//
// 	});
//
// 	$('#sub.search_idx .product_list .tp_wrap .r_box ul li').on('click',function(){
// 		var idx = $(this).index();
// 		$(this).siblings().removeClass('on');
// 		$(this).addClass('on');
// 		$('#sub.search_idx .product_list .prd_list .prd_box').removeClass('on');
// 		$('#sub.search_idx .product_list .prd_list .prd_box').eq(idx).addClass('on');
//
// 	});
//
// 	/*$('#sub.view_idx .box_wrap .ul_wrap ul li').on('click',function(){
// 		var idx = $(this).index();
// 		console.log(idx);
// 		$(this).siblings().removeClass('on');
// 		$(this).addClass('on');
// 		$('#sub.view_idx .box_wrap .info_wrap').removeClass('on');
// 		$('#sub.view_idx .box_wrap .info_wrap').eq(idx).addClass('on');
//
// 	});*/
// 	$('.hrt_btn a').on('click',function(){
// 		if($(this).hasClass('on')){
// 			$(this).removeClass('on');
// 		}else{
// 			$(this).addClass('on');
// 		}
// 	});
// 	/*var allFlag = false;
// 	$('#fixed_header .all_menu .l_box ul li').on('mouseenter',function(){
// 			var idx = $(this).index();
// 			if($(this).hasClass('on')){
// 			}else{
// 				if(allFlag == false) {
// 					$('#fixed_header .all_menu .l_box').addClass('act');
// 					$('#fixed_header .all_menu .r_box').removeClass('act');
// 					$('#fixed_header .all_menu .r_box').eq(idx).addClass('act');
// 					$(this).siblings().removeClass('on');
// 					$(this).addClass('on');
// 				}
// 				allFlag = true;
// 			}
// 			if($(this).hasClass('long')){
// 				$('#fixed_header .all_menu').css('max-width', '100%');
// 			}else{
// 				$('#fixed_header .all_menu').css('max-width', '500px');
// 			}
//
// 		}).on('mouseleave',function(){
// 			if($(this).hasClass('on')){
// 				var idx = $(this).index();
// 				$(this).removeClass('on');
// 				//$('.allgnb .menus ul').eq(idx).removeClass('on');
// 			}else{
// 				if(allFlag == true){
// 					$('#fixed_header .all_menu .l_box').removeClass('act');
// 					$('#fixed_header .all_menu .r_box').removeClass('act');
// 					$(this).siblings().removeClass('on');
// 					$(this).removeClass('on');
// 				}
// 				allFlag = false;
// 			}
// 		});*/
// 	$('#fixed_header .all_menu .l_box ul li').on('mouseenter',function(){
// 		var idx = $(this).index();
// 		$('#fixed_header .all_menu .l_box').addClass('act');
// 		$('#fixed_header .all_menu .r_box').removeClass('act');
// 		$('#fixed_header .all_menu .r_box').eq(idx).addClass('act');
// 		$(this).siblings().removeClass('on');
// 		$(this).addClass('on');
//
// 		if($(this).hasClass('long')){
// 				$('#fixed_header .all_menu').css('max-width', '100%');
// 			}else{
// 				$('#fixed_header .all_menu').css('max-width', '500px');
// 			}
// 	});
// 	$('#header li.mp').on('mouseleave',function(){
// 		var idx = $(this).index();
// 		$('#fixed_header .all_menu .l_box').removeClass('act');
// 		$('#fixed_header .all_menu .r_box').removeClass('act');
// 		$(this).siblings().removeClass('on');
// 		$(this).removeClass('on');
// 	});
//
// 	$('.nav > ul > li.dp ').on('mouseenter',function(){
// 		if ($(this).hasClass('on')){
//
// 		}else{
// 			$(this).addClass('on');
// 			$('.nav > ul > li .depth').stop().fadeIn(400);
// 		}
//
// 		}).on('mouseleave',function(){
// 			$(this).removeClass('on');
// 			$('.nav > ul > li .depth').stop().fadeOut(400);
// 		});
//
//
// 	$('#fixed_header .all_btn a.pc').on('click',function(){
// 		if($(this).hasClass('on')){
// 			$(this).removeClass('on');
// 			$('#fixed_header .all_menu').stop().fadeOut(400);
// 		}else{
// 			$(this).addClass('on');
// 			$('#fixed_header .all_menu').stop().fadeIn(400);
// 		}
// 	});
// 	$('.mo_all_menu .mp_wrap > a').on('click',function(){
// 		if($(this).hasClass('on')){
// 			$(this).removeClass('on');
// 			$(this).parent().find('.dept').stop().slideUp(400);
// 			$('.mo_all_menu .mo_bg').stop().fadeOut(400);
//
// 		}else{
// 			$(this).addClass('on');
// 			$(this).parent().find('.dept').stop().slideDown(400);
// 			$('.mo_all_menu .mo_bg').stop().fadeIn(400);
// 		}
// 	});
//
// 	$('#fixed_header .all_menu a.close').on('click',function(){
//
// 			$('#fixed_header .all_btn a').removeClass('on');
// 			$('#fixed_header .all_menu').stop().fadeOut(400);
//
// 	});
//
// 	$('.mo_all_menu .category_wrap > ul > li > .tb > a').on('click',function(){
// 		if($(this).hasClass('on')){
//
// 			$(this).removeClass('on');
// 			$(this).parent().siblings('.dept').stop().slideUp(400);
// 		}else{
// 			$('.mo_all_menu .category_wrap > ul > li > .dept').stop().slideUp(400);
// 			$('.mo_all_menu .category_wrap > ul > li > .tb > a').removeClass('on');
// 			$(this).addClass('on');
// 			$(this).parent().siblings('.dept').stop().slideDown(400);
//
// 		}
// 	});
// 	$('.sub_depth .dep > div > a').on('click',function(){
// 		if($(this).hasClass('on')){
// 			$(this).removeClass('on');
// 			$(this).siblings('ul').stop().slideUp(400);
// 			$('.dep_bg').stop().fadeOut(400);
// 		}else{
// 			$('.sub_depth .dep > div > ul').stop().slideUp(400);
// 			$('.sub_depth .dep > div > a').removeClass('on');
// 			$(this).addClass('on');
// 			$(this).siblings('ul').stop().slideDown(400);
// 			$('.dep_bg').stop().fadeIn(400);
// 		}
// 	});
//
// 	$('.dep_bg').on('click', function(){
// 		$('.sub_depth .dep > div > ul').stop().slideUp(400);
// 		$('.sub_depth .dep > div > a').removeClass('on');
// 		$('.dep_bg').stop().fadeOut(400);
// 	});
// 	$('#sub .dev_wrap .r_wrap .filter_list .wrap > a').on('click',function(){
// 		if($(this).hasClass('on')){
// 			$(this).removeClass('on');
// 			$(this).siblings('.ul_list').stop().slideUp(400);
// 		}else{
// 			$(this).addClass('on');
// 			$(this).siblings('.ul_list').stop().slideDown(400);
// 		}
//
//
// 	});
// 	$('#sub .dev_wrap .r_wrap .filter_list .wrap.cat > a').on('click',function(){
// 		if($(this).hasClass('on')){
// 			$('.r_bt').addClass('on');
// 		}else{
// 			$('.r_bt').removeClass('on');
// 		}
// 	});
// 	$('#quick_menu .tp_wrap .quick_close').on('click',function(){
// 		$('#quick_menu').addClass('sm');
// 		/*if($('#quick_menu').hasClass('sm')){
// 			$('#quick_menu').removeClass('sm');
// 		}else{
// 			$('#quick_menu').addClass('sm');
// 		}*/
//
// 	});
//
// 	$('#quick_menu .sm_wrap a').on('click',function(){
// 		$('#quick_menu').removeClass('sm');
// 	});
//
// 	$('.search_list .list_wrap ul li a.cls').on('click',function(){
// 		$(this).parent().remove();
// 	});
// 	$('.filter_list .wrap .ul_list ul li a.cls').on('click',function(){
// 		$(this).parent().remove();
// 	});
// 	$('.rec_list .box a.cls').on('click',function(){
// 		$(this).parent().remove();
// 	});
// 	$('#sub .dev_wrap .r_wrap .filter_list .wrap.cat .reset_btn').on('click',function(){
// 		$('.filter_list .wrap.cat .ul_list ul li').remove();
// 	});
// 	$('.search_list .btm_wrap .list_del a').on('click',function(){
// 		$('.search_list .list_wrap ul li').remove();
// 	});
// 	$('.search_list .btm_wrap .list_cls a').on('click',function(){
// 		$('#fixed_header .s_wrap .search_wrap .search_list').stop().fadeOut(400);
// 	});
// 	$("#fixed_header .s_wrap .search_wrap .search_box input[type='text']" ).on('click',function() {
//
// 		$('#fixed_header .s_wrap .search_wrap .search_list').stop().fadeIn(400);
// 	});
//
//
// 	if($('#main').length > 0){
// 		var pos = $(document).scrollTop();
// 		var hbH = $('#header').outerHeight();
// 		var mbH = $('#main .main_visual').outerHeight();
// 		var tpH = hbH + mbH;
// 		console.log(pos);
//
// 		if(pos > tpH ){
// 			$('#quick_menu').addClass('fixed');
// 		}else{
// 			$('#quick_menu').removeClass('fixed');
// 		}
//
// 	}else{
// 		$('#quick_menu').css('top','500px');
// 		if(pos > hbH){
// 			$('#quick_menu').addClass('fixed');
// 		}else{
// 			$('#quick_menu').removeClass('fixed');
// 		}
// 	}
// 	/*달력*/
// 	 $( '#date1').datepicker({
// 			dateFormat: 'yy/mm/dd',
// 			prevText: '이전 달',
// 			nextText: '다음 달',
// 			monthNames: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
// 			monthNamesShort: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
// 			dayNames: ['일','월','화','수','목','금','토'],
// 			dayNamesShort: ['일','월','화','수','목','금','토'],
// 			dayNamesMin: ['일','월','화','수','목','금','토'],
// 			showMonthAfterYear: true,
// 			changeMonth: true,
// 			changeYear: true,
// 			yearSuffix: '년',
// 			//minDate : '+0d',
// 			isRTL: false,
// 			yearRange : 'c-30:c+0'
// 		});
// 		 $( '#date2').datepicker({
// 			dateFormat: 'yy/mm/dd',
// 			prevText: '이전 달',
// 			nextText: '다음 달',
// 			monthNames: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
// 			monthNamesShort: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
// 			dayNames: ['일','월','화','수','목','금','토'],
// 			dayNamesShort: ['일','월','화','수','목','금','토'],
// 			dayNamesMin: ['일','월','화','수','목','금','토'],
// 			showMonthAfterYear: true,
// 			changeMonth: true,
// 			changeYear: true,
// 			yearSuffix: '년',
// 			//minDate : '+0d',
// 			isRTL: false,
// 			yearRange : 'c-30:c+0'
// 		});
// 		  $( '#date3').datepicker({
// 			dateFormat: 'yy/mm/dd',
// 			prevText: '이전 달',
// 			nextText: '다음 달',
// 			monthNames: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
// 			monthNamesShort: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
// 			dayNames: ['일','월','화','수','목','금','토'],
// 			dayNamesShort: ['일','월','화','수','목','금','토'],
// 			dayNamesMin: ['일','월','화','수','목','금','토'],
// 			showMonthAfterYear: true,
// 			changeMonth: true,
// 			changeYear: true,
// 			yearSuffix: '년',
// 			//minDate : '+0d',
// 			isRTL: false,
// 			yearRange : 'c-30:c+0'
// 		});
// 		 $( '#date4').datepicker({
// 			dateFormat: 'yy/mm/dd',
// 			prevText: '이전 달',
// 			nextText: '다음 달',
// 			monthNames: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
// 			monthNamesShort: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
// 			dayNames: ['일','월','화','수','목','금','토'],
// 			dayNamesShort: ['일','월','화','수','목','금','토'],
// 			dayNamesMin: ['일','월','화','수','목','금','토'],
// 			showMonthAfterYear: true,
// 			changeMonth: true,
// 			changeYear: true,
// 			yearSuffix: '년',
// 			//minDate : '+0d',
// 			isRTL: false,
// 			yearRange : 'c-30:c+0'
// 		});
// });
//
//
//
// $(window).scroll(function(){
// 	var pos = $(document).scrollTop();
// 	//console.log(pos);
// 	var width  = $(document).outerWidth();
// 	var hb = $('.header_banner').outerHeight();
// 	var hb2 = $('#fixed_header').outerHeight();
// 	/*header*/
// 	if($('.header_banner').length > 0){
//
// 		if(pos > hb ){
// 			$('#fixed_header').addClass('fixed');
// 			$('#main,#sub').css('padding-top',hb2);
// 		}else{
// 			$('#fixed_header').removeClass('fixed');
// 			$('#main,#sub').css('padding-top','0');
// 		}
// 	}else{
// 		if(pos > 0){
// 			$('#fixed_header').addClass('fixed');
// 			$('#main,#sub').css('padding-top',hb2);
// 		}else{
// 			$('#fixed_header').removeClass('fixed');
// 			$('#main,#sub').css('padding-top','0');
// 		}
// 	}
//
//
// 	if($('#main').length > 0){
// 		var pos = $(document).scrollTop();
// 		var hbH = $('#header').outerHeight();
// 		var mbH = $('#main .main_visual').outerHeight();
// 		var tpH = hbH + mbH;
// 		console.log(hbH)
//
// 		if(pos > tpH){
// 			$('#quick_menu').addClass('fixed');
// 		}else{
// 			$('#quick_menu').removeClass('fixed');
// 		}
//
// 	}else{
// 		if(pos > hbH + 50){
// 			$('#quick_menu').addClass('fixed');
// 		}else{
// 			$('#quick_menu').removeClass('fixed');
// 		}
// 	}
//
//
//
//
// });
//
//
// $( window ).resize(function(){
// 	var wWid = $( window ).width();
// 	if (wWid < 960){
// 		var gnb = new Swiper('.btm_header .gnb_sl .swiper-container', {
// 			slidesPerView: "auto",
// 			navigation: {
// 				nextEl: '.gnb_sl .r_btn',
// 				prevEl: '.gnb_sl .l_btn',
// 			},
// 		});
// 	}
//
// });
// var wWid = $( window ).width();
// 	if (wWid < 960){
// 		$(document).ready(function(){
// 			var gnb = new Swiper('.btm_header .gnb_sl .swiper-container', {
// 					slidesPerView: "auto",
// 					navigation: {
// 					nextEl: '.gnb_sl .r_btn',
// 					prevEl: '.gnb_sl .l_btn',
// 				},
// 			});
// 		});
// 	}
//
// /* 삭제하지 말것 */
// String.prototype.replaceAll = function(org, dest) {
//     return this.split(org).join(dest);
// }
//
// function refresh_captcha(){
// 	document.getElementById("capt_img").src="/include/captcha.php?waste="+Math.random();
// 	return false;
// }
// function getThumbnailPrivew(html, $target) {
//     if (html.files && html.files[0]) {
//         var reader = new FileReader();
//         reader.onload = function (e) {
//             $target.addClass('on');
//             $target.css('background-image', 'url(\"' + e.target.result + '\")'); // 배경으로 지정시
//            // $target.html('<img src="' + e.target.result + '" class="listImg" alt="" />');
//         }
//         reader.readAsDataURL(html.files[0]);
//     }
// }
//
// function openPopup(id){
// 	$('#'+id).stop().fadeIn(400);
// }
//
// function closePopup(id){
//
// 	$('#'+id).stop().fadeOut(400);
// }
//
// /*동적*/
// $(document).on("click","#btn",function(){});
//
// function alertFun() {
//   alert("자식 컴퍼넌트 로드시 매번 출력되야 하는 함수")
// }
//
//
// /* - - - - - - - - - */



// WEBPACK FOOTER //
// ./src/assets/js/common/common.js